import { FORECAST_TABLE_PARAMS } from "../constants";

// sum(feature[i] * days[i]) \ sum(days)
export const prepareNumber = (data: any, property: string) => {
  let value = 0;
  for (let i = 0; i < data.length; i++) {
    const rowVal = data[i][property] || 0;
    const numberOfDays = data[i][FORECAST_TABLE_PARAMS.numberOfDays] || 0;
    const valWithWeight = rowVal * numberOfDays;
    value += valWithWeight;
  }

  if (!value && !prepareSum(data, FORECAST_TABLE_PARAMS.numberOfDays)) {
    return 0;
  }

  return Number(
    value / prepareSum(data, FORECAST_TABLE_PARAMS.numberOfDays)
  ).toFixed(2);
};

export const prepareSum = (data: any, property: string) => {
  let value = 0;
  for (let i = 0; i < data.length; i++) {
    const rowVal = data[i][property] || 0;
    value += rowVal;
  }

  return Number(value);
};

export const prepareDataForExport = (forecastData) => {
  const data = [];

  for (const row of forecastData) {
    data.push({
      "Input SP": row.inputStockpile,
      "# of Days": row[FORECAST_TABLE_PARAMS.numberOfDays],
      [FORECAST_TABLE_PARAMS.Zn_Fd]: row[FORECAST_TABLE_PARAMS.Zn_Fd],
      [FORECAST_TABLE_PARAMS.Pb_Fd]: row[FORECAST_TABLE_PARAMS.Pb_Fd],
      [FORECAST_TABLE_PARAMS.Zn_Rec]: row[FORECAST_TABLE_PARAMS.Zn_Rec],
      [FORECAST_TABLE_PARAMS.Zn_Gr]: row[FORECAST_TABLE_PARAMS.Zn_Gr],
      [FORECAST_TABLE_PARAMS.Pb_Rec]: row[FORECAST_TABLE_PARAMS.Pb_Rec],
      [FORECAST_TABLE_PARAMS.Pb_Gr]: row[FORECAST_TABLE_PARAMS.Pb_Gr],
      "Matched SP": row[FORECAST_TABLE_PARAMS.SP],
      [FORECAST_TABLE_PARAMS.TPOH]: row[FORECAST_TABLE_PARAMS.TPOH],
    });
  }

  const avgRow = {
    "Input SP": "Avg.",
    "# of Days": prepareSum(forecastData, FORECAST_TABLE_PARAMS.numberOfDays),
    [FORECAST_TABLE_PARAMS.Zn_Fd]: prepareNumber(
      forecastData,
      FORECAST_TABLE_PARAMS.Zn_Fd
    ),
    [FORECAST_TABLE_PARAMS.Pb_Fd]: prepareNumber(
      forecastData,
      FORECAST_TABLE_PARAMS.Pb_Fd
    ),
    [FORECAST_TABLE_PARAMS.Zn_Rec]: prepareNumber(
      forecastData,
      FORECAST_TABLE_PARAMS.Zn_Rec
    ),
    [FORECAST_TABLE_PARAMS.Zn_Gr]: prepareNumber(
      forecastData,
      FORECAST_TABLE_PARAMS.Zn_Gr
    ),
    [FORECAST_TABLE_PARAMS.Pb_Rec]: prepareNumber(
      forecastData,
      FORECAST_TABLE_PARAMS.Pb_Rec
    ),
    [FORECAST_TABLE_PARAMS.Pb_Gr]: prepareNumber(
      forecastData,
      FORECAST_TABLE_PARAMS.Pb_Gr
    ),
    "Matched SP": "-",
    [FORECAST_TABLE_PARAMS.TPOH]: prepareNumber(
      forecastData,
      FORECAST_TABLE_PARAMS.TPOH
    ),
  };
  data.push(avgRow);

  return data;
};
